import { getProfileThumbnail } from "@shared/hooks/useProfile";
import React from "react";

interface Attendee {
  userId: string;
  name?: string;
  avatarUrl?: string;
}

interface EventAttendeesAvatarsProps {
  attendees?: Attendee[];
  createdByProfile?: {
    id: string;
    imageUrl?: string;
    name?: string;
  };
}

const EventAttendeesAvatars: React.FC<EventAttendeesAvatarsProps> = ({
  attendees,
  createdByProfile,
}) => {
  if (attendees && attendees.length > 0) {
    return (
      <div className="flex items-center space-x-2">
        <div
          className={`flex ${attendees.length > 1 ? "-space-x-3 -ml-0.5" : ""}`}
        >
          {attendees.slice(0, 3).map((att, idx) => (
            <img
              key={att.userId || idx}
              className="w-7 h-7 rounded-full border-2 border-white dark:border-gray-800 box-content object-cover"
              src={getProfileThumbnail(att)}
              alt={att.name || `User ${idx + 1}`}
            />
          ))}
        </div>
        {attendees.length > 3 && (
          <div className="text-xs font-medium text-gray-400 dark:text-gray-500 italic">
            +{attendees.length - 3}
          </div>
        )}
      </div>
    );
  }
  // If there are no attendees, show only the creator
  return createdByProfile?.imageUrl ? (
    <div className="flex items-center space-x-2">
      <div className="flex -space-x-3 -ml-0.5">
        <img
          className="w-8 h-8 rounded-full mr-3 group-hover:ring-2 group-hover:ring-blue-400 transition"
          src={createdByProfile.imageUrl}
          alt={createdByProfile.name || "User"}
        />
      </div>
    </div>
  ) : null;
};

export default EventAttendeesAvatars;
